import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "placeholder"]




export default /*#__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
    modelValue: {},
    placeholder: {},
    wide: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "text",
    value: _ctx.modelValue,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (
      _ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value)
    )),
    placeholder: _ctx.placeholder,
    class: _normalizeClass(`input input-bordered input-success ${_ctx.wide ? 'w-80' : ''}`)
  }, null, 42, _hoisted_1))
}
}

})